const tax_rate = 10;
const insurance_rate = 0.297 / 100;

const calcul_mensualite_max = (salaire, dette_mensuelle, acompte, taux_interet = 4.2, duree_mois = 300, capacite_endettement = 45) => {

    let mensualiteMax = salaire * capacite_endettement / 100 - dette_mensuelle;
    if (mensualiteMax < 0) {
        mensualiteMax = 0;
    }
    let budget = calcul_budget(
        mensualiteMax,
        acompte,
        taux_interet / 100,
        duree_mois
    );
    return {
        mensualite: budget["mensualite"],
        budget: budget["budget"],
    };


}

export const calcul_budget = (mensualite, acompte, taux_interet, programmedette) => {
    let prixmaison = acompte + (mensualite * (1 - Math.pow(1 + taux_interet / 12, -programmedette))) /
        (taux_interet / 12);
    let new_courbes = update_courbes(
        prixmaison,
        acompte,
        mensualite,
        programmedette,
        taux_interet
    );
    return {
        mensualite:
            mensualite + new_courbes["assurances"][0] + new_courbes["tva"][0],
        budget: prixmaison,
    };
};
export const update_courbes = (
    prixmaison,
    acompte,
    mensualite,
    programmedepret,
    tauxdinteret
) => {
    let tva = [];
    let interets = [];
    let interets_cumules = [0];
    let principal_rembourse = [0];
    let principal = [];
    let assurances = [];

    let capital_restant = [prixmaison - acompte];
    for (let i = 0; i < programmedepret; i++) {
        tva = tva.concat([
            (capital_restant[i] * (tax_rate / 100) * tauxdinteret) / 1200,
        ]);
        interets = interets.concat([(capital_restant[i] * tauxdinteret) / 1200]);
        interets_cumules = interets_cumules.concat([
            (capital_restant[i] * tauxdinteret) / 1200 + interets_cumules[i],
        ]);

        assurances = assurances.concat([
            (capital_restant[i] * insurance_rate) / 12,
        ]);

        principal = principal.concat([
            mensualite - interets[i],
        ]);

        principal_rembourse = principal_rembourse.concat([
            principal_rembourse[i] + principal[i],
        ]);

        capital_restant = capital_restant.concat([
            capital_restant[i] - principal[i],
        ]);
    }
    return {
        tva: tva,
        principal_rembourse: principal_rembourse,
        interets_cumules: interets_cumules,
        interets: interets,
        principal: principal,
        assurances: assurances,
        capital_restant: capital_restant,
    };
};
export default calcul_mensualite_max
